// Tracks whether a player has already been shown a game's How To Play slides,
// so the lobby only auto-opens them on the first visit. Stored per player +
// game in localStorage. Storage can throw inside the operator wrapper iframe
// (blocked third-party storage), so every access is guarded — a failed read
// reports "seen" so the popup never loops on every lobby visit.

const storageKey = (playerId, gameId) =>
  playerId
    ? `howToPlaySeen:${playerId}:${gameId}`
    : `howToPlaySeen:${gameId}`;

export const hasSeenHowToPlay = (playerId, gameId) => {
  try {
    return localStorage.getItem(storageKey(playerId, gameId)) === "1";
  } catch {
    return true;
  }
};

export const markHowToPlaySeen = (playerId, gameId) => {
  try {
    localStorage.setItem(storageKey(playerId, gameId), "1");
  } catch {
    // Storage unavailable — nothing to persist.
  }
};
